var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5306 5.53063L6.5306 13.5306C6.46092 13.6005 6.37813 13.656 6.28696 13.6939C6.1958 13.7317 6.09806 13.7512 5.99935 13.7512C5.90064 13.7512 5.8029 13.7317 5.71173 13.6939C5.62057 13.656 5.53778 13.6005 5.4681 13.5306L1.9681 10.0306C1.89833 9.96087 1.84299 9.87804 1.80524 9.78689C1.76748 9.69574 1.74805 9.59804 1.74805 9.49938C1.74805 9.40072 1.76748 9.30302 1.80524 9.21187C1.84299 9.12072 1.89833 9.03789 1.9681 8.96813C2.03786 8.89837 2.12069 8.84302 2.21184 8.80527C2.30299 8.76751 2.40069 8.74808 2.49935 8.74808C2.59801 8.74808 2.69571 8.76751 2.78686 8.80527C2.87801 8.84302 2.96083 8.89837 3.0306 8.96813L5.99997 11.9375L13.4693 4.46938C13.6102 4.32848 13.8013 4.24933 14.0006 4.24933C14.1999 4.24933 14.391 4.32848 14.5318 4.46938C14.6727 4.61028 14.7519 4.80137 14.7519 5.00063C14.7519 5.19989 14.6727 5.39098 14.5318 5.53188L14.5306 5.53063Z",
    fill: "#030102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.324467c61a18471057c452c6a33cb041.svg";
export { ForwardRef as ReactComponent };